import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useReleaseMotionArtworkSchema = () => {
    const { t } = useTranslation();

    return yup.object({
        assetType: yup.string().required(t("messages.inputMsgs.required")),
        motionArtwork: yup.mixed().required(t("messages.inputMsgs.required")),
    });
};

export default useReleaseMotionArtworkSchema;
